export const START_LOADING = 'app/services/Customers/START_LOADING';
export const START_CUSTOMERS_REQUEST = 'app/services/Customers/START_CUSTOMERS_REQUEST';

export const SELECT_VIEW = 'app/services/Customers/SELECT_VIEW';
export const ADD_FILTER = 'app/services/Customers/ADD_FILTER';
export const SET_FILTERS = 'app/services/Customers/SET_FILTERS';
export const REMOVE_FILTER = 'app/services/Customers/REMOVE_FILTER';
export const CLEAR_FILTERS = 'app/services/Customers/CLEAR_FILTERS';
export const SET_COLUMNS = 'app/services/Customers/SET_COLUMNS';
export const SET_SEARCH_QUERY = 'app/services/Customers/SET_SEARCH_QUERY';
export const RESET_CUSTOMERS_DATA = 'app/services/Customers/RESET_CUSTOMERS_DATA';

export const SET_CUSTOMERS_OFFSET = 'app/services/Customers/SET_CUSTOMERS_OFFSET';
export const CLEAR_CUSTOMER = 'app/services/Customers/CLEAR_CUSTOMER';
export const GET_CUSTOMERS_SUCCESS = 'app/services/Customers/GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAIL = 'app/services/Customers/GET_CUSTOMERS_FAIL';
export const GET_CUSTOMER_SUCCESS = 'app/services/Customers/GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAIL = 'app/services/Customers/GET_CUSTOMER_FAIL';
export const CREATE_CUSTOMER_SUCCESS = 'app/services/Customers/CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAIL = 'app/services/Customers/CREATE_CUSTOMER_FAIL';
export const UPDATE_CUSTOMER_SUCCESS = 'app/services/Customers/UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAIL = 'app/services/Customers/UPDATE_CUSTOMER_FAIL';
export const ADD_CUSTOMER_NOTE_SUCCESS = 'app/services/Customers/ADD_NOTE_SUCCESS';
export const ADD_CUSTOMER_NOTE_FAIL = 'app/services/Customers/ADD_NOTE_FAIL';
export const UPDATE_CUSTOMER_NOTE_SUCCESS = 'app/services/Customers/UPDATE_CUSTOMER_NOTE_SUCCESS';
export const UPDATE_CUSTOMER_NOTE_FAIL = 'app/services/Customers/UPDATE_CUSTOMER_NOTE_FAIL';
export const GET_HISTORY_SUCCESS = 'app/services/Customer/GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAIL = 'app/services/Customer/GET_HISTORY_FAIL';
export const GET_CUSTOMER_VEHICLES_SUCCESS = 'app/services/Customers/GET_CUSTOMER_VEHICLES_SUCCESS';
export const GET_CUSTOMER_VEHICLES_FAIL = 'app/services/Customers/GET_CUSTOMER_VEHICLES_FAIL';
export const CHANGE_PER_PAGE_VALUE = 'app/services/Customers/CHANGE_PER_PAGE_VALUE';
export const GET_CUSTOMER_DEFAULT_CREDITCARD_SUCCESS = 'app/services/Customers/GET_CUSTOMER_DEFAULT_CREDITCARD_SUCCESS';
export const GET_CUSTOMER_DEFAULT_CREDITCARD_FAIL = 'app/services/Customers/GET_CUSTOMER_DEFAULT_CREDITCARD_FAIL';
export const GENERATE_STRIPE_PORTAL_SESSION_SUCCESS = 'app/services/Customers/GENERATE_STRIPE_PORTAL_SESSION_SUCCESS';
export const GENERATE_STRIPE_PORTAL_SESSION_FAIL = 'app/services/Customers/GENERATE_STRIPE_PORTAL_SESSION_FAIL';
export const CLEAR_STRIPE_PORTAL_SESSION = 'app/services/Customers/CLEAR_STRIPE_PORTAL_SESSION';
export const POST_CUSTOMER_CHECKING_SUCCESS = 'app/services/Customers/POST_CUSTOMER_CHECKING_SUCCESS';
export const POST_CUSTOMER_CHECKING_FAIL = 'app/services/Customers/POST_CUSTOMER_CHECKING_FAIL';
export const ARCHIVE_CUSTOMERS_BY_ID = 'app/services/Customers/ARCHIVE_CUSTOMERS_BY_ID';

export const startLoading = () => ({
  type: START_LOADING,
});

export const startCustomersRequest = (requestId) => ({
  type: START_CUSTOMERS_REQUEST,
  payload: { requestId },
});

export const receivedSelectedView = (view) => ({
  type: SELECT_VIEW,
  payload: { view },
});

export const receivedNewFilter = (filter) => ({
  type: ADD_FILTER,
  payload: { filter },
});

export const receivedRemoveFilter = (index) => ({
  type: REMOVE_FILTER,
  payload: { index },
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: { filters },
});

export const receivedClearFilters = () => ({
  type: CLEAR_FILTERS,
});
export const receivedClearCustomer = () => ({
  type: CLEAR_CUSTOMER,
});

export const receivedSetColumns = (columns) => ({
  type: SET_COLUMNS,
  payload: { columns },
});

export const receivedResetCustomers = () => ({
  type: RESET_CUSTOMERS_DATA,
});

export const receivedCustomersOffset = (offset) => ({
  type: SET_CUSTOMERS_OFFSET,
  payload: { offset },
});

export const receivedSetSearchQuery = (searchQuery) => ({
  type: SET_SEARCH_QUERY,
  payload: { searchQuery },
});

export const receivedCustomersSuccess = (data, offset, requestId) => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: {
    data,
    offset,
    requestId,
  },
});

export const receivedAddCustomerNoteSuccess = (note) => ({
  type: ADD_CUSTOMER_NOTE_SUCCESS,
  payload: { note },
});

export const receivedAddCustomerNoteFail = (errors) => ({
  type: ADD_CUSTOMER_NOTE_FAIL,
  payload: { errors },
});

export const receivedUpdateCustomerNoteSuccess = (notes) => ({
  type: UPDATE_CUSTOMER_NOTE_SUCCESS,
  payload: { notes },
});

export const receivedUpdateCustomerNoteFail = (errors) => ({
  type: UPDATE_CUSTOMER_NOTE_FAIL,
  payload: { errors },
});

export const receivedCustomersFail = (errors, requestId) => ({
  type: GET_CUSTOMERS_FAIL,
  payload: { errors, requestId },
});

export const receivedPerPageValue = (perPage) => ({
  type: CHANGE_PER_PAGE_VALUE,
  payload: { perPage },
});

export const receivedCustomerSuccess = (customer) => ({
  type: GET_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const receivedCustomerFail = (errors) => ({
  type: GET_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedCustomerCreationSuccess = (customer) => ({
  type: CREATE_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const receivedCustomerCreationFail = (errors) => ({
  type: GET_CUSTOMER_FAIL,
  payload: { errors },
});

export const receivedCustomerUpdatedSuccess = (customer) => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload: { customer },
});

export const receivedCustomerUpdatedFail = (errors) => ({
  type: UPDATE_CUSTOMER_FAIL,
  payload: { errors },
});

export const archiveCustomersById = (ids: number[], pageNumber: number) => ({
  type: ARCHIVE_CUSTOMERS_BY_ID,
  payload: { ids, pageNumber },
});

export const receivedCustomerVehiclesSuccess = (vehicles) => ({
  type: GET_CUSTOMER_VEHICLES_SUCCESS,
  payload: { vehicles },
});

export const receivedCustomerVehiclesFail = (errors) => ({
  type: GET_CUSTOMER_VEHICLES_FAIL,
  payload: { errors },
});

export const receivedHistorySuccess = (data) => ({
  type: GET_HISTORY_SUCCESS,
  payload: {
    data,
  },
});

export const receivedHistoryFail = (errors) => ({
  type: GET_HISTORY_FAIL,
  payload: {
    errors,
  },
});

export const receivedCustomerDefaultCreditcardSuccess = (creditcard) => ({
  type: GET_CUSTOMER_DEFAULT_CREDITCARD_SUCCESS,
  payload: { creditcard },
});

export const receivedCustomerDefaultCreditcardFail = (errors) => ({
  type: GET_CUSTOMER_DEFAULT_CREDITCARD_FAIL,
  payload: { errors },
});

export const receivedGenerateStripePortalSessionSuccess = (link?: string) => ({
  type: GENERATE_STRIPE_PORTAL_SESSION_SUCCESS,
  payload: { link },
});

export const receivedGenerateStripePortalSessionFail = (errors) => ({
  type: GENERATE_STRIPE_PORTAL_SESSION_FAIL,
  payload: { errors },
});

export const clearStripePortalSession = () => ({
  type: CLEAR_STRIPE_PORTAL_SESSION,
});

export const receivedPostCustomerCheckingSuccess = () => ({
  type: POST_CUSTOMER_CHECKING_SUCCESS,
  payload: {},
});

export const receivedPostCustomerCheckingFail = (errors) => ({
  type: POST_CUSTOMER_CHECKING_FAIL,
  payload: { errors },
});
